// Reusable circular orbit pattern decoration
const OrbitPattern = ({ size = 800, opacity = 0.12, color = "#E8D3C3", className = "", style = {} }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 800 800"
      fill="none"
      className={`pointer-events-none ${className}`}
      style={{ opacity, ...style }}
      aria-hidden="true"
    >
      <circle cx="400" cy="400" r="380" stroke={color} strokeWidth="0.8" />
      <circle cx="400" cy="400" r="300" stroke={color} strokeWidth="0.8" />
      <circle cx="400" cy="400" r="220" stroke={color} strokeWidth="0.8" />
      <circle cx="400" cy="400" r="140" stroke={color} strokeWidth="0.8" />
      <circle cx="400" cy="400" r="60" stroke={color} strokeWidth="0.8" />
    </svg>
  );
};

export default OrbitPattern;
